(function () {

  'use strict';

  function pxTransactions(
    $filter, $http, TransactionsListPaging, STRIPE_PUBLISHABLE_KEY, $rootScope,
    EventServiceEvents, TEMPLATE_PATHS, $ngBootbox, $translate
  ) {
    return {
      restrict: 'EA',
      scope: {
        me: '=me',
        billingData: '=billingData',
        tenant: '=tenant',
        callback: '&callback'
      },
      templateUrl: 'app/components/subscription/transactions/transactions.template.html',
      link: function (scope) {

        scope.transactionListPaging = new TransactionsListPaging();
        scope.transactionsList = null;
        scope.transactionsListPageInfo = null;
        scope.invoiceNumber = null;

        (function () {
          getTransactionsListPaged();
        })();

        scope.setSection = function () {
          scope.callback();
        };

        function getTransactionsListPaged() {
          scope.tenant.getTransactions(scope.billingData._links['px:charges'].href, scope.transactionListPaging)
            .then(function (response) {
              addAttribute(response);
              scope.transactionsList = response.data._embedded ? response.data._embedded['px:chargeResources'] : null;
              scope.transactionsListPageInfo = response.data.page;
            })
            .catch(function () {
            });
        };

        scope.getNextPage = function functionName() {
          if (scope.transactionListPaging.pagingCriteria.page + 1 < scope.transactionsListPageInfo.totalPages) {
            scope.transactionListPaging.pagingCriteria.page++;
            getTransactionsListPaged();
          }
        };

        scope.getPreviousPage = function functionName() {
          if (scope.transactionListPaging.pagingCriteria.page > 0) {
            scope.transactionListPaging.pagingCriteria.page--;
            getTransactionsListPaged();
          }
        };

        function addAttribute(response) {
          if (response.data._embedded) {
            const charges = response.data._embedded['px:chargeResources'];
            angular.forEach(charges, function (charge) {
              charge.hide = charge.hide || null;
            });
          }
        }

        scope.formatCurrency = function (amount, currency) {
          if (amount && currency) {
            return amount.toLocaleString($translate.use(), { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency });
          }
          return undefined;
        };

        scope.performRequiredStripeAction = function (transaction) {
          switch (transaction.ccPaymentIntentStatus) {
            case 'REQUIRES_ACTION':
              checkPaymentIntentStatus(transaction);
              break;
            case 'REQUIRES_PAYMENT_METHOD':
            case 'CANCELED':
            case 'CREATE_FAILED_WITH_CARD_ERROR':
              retryPayment(transaction);
              break;
          }
        };

        function checkPaymentIntentStatus(transaction) {
          transaction.working = true;
          const stripe = Stripe(STRIPE_PUBLISHABLE_KEY);
          stripe.retrievePaymentIntent(transaction.ccPaymentIntentClientSecret)
            .then(function (response) {
              if (response.paymentIntent) {
                if (response.paymentIntent.status === 'requires_action') {
                  if (response.paymentIntent.next_action && response.paymentIntent.next_action.use_stripe_sdk) {
                    stripeHandleConfirmCardAction(transaction);
                  } else {
                    stripeHandleCardAction(transaction);
                  }
                } else {
                  scope.printixCardActionHandled(transaction);
                }
              }
              if (response.error) {
                transaction.working = false;
              }
            })
            .catch(function () {
            });
        }

        function stripeHandleConfirmCardAction(transaction) {
          const stripe = Stripe(STRIPE_PUBLISHABLE_KEY);
          stripe.confirmCardPayment(transaction.ccPaymentIntentClientSecret)
            .then(function (response) {
              if (response.paymentIntent) {
                scope.printixCardActionHandled(transaction);
              }
              if (response.error) {
                transaction.working = false;
              }
            });
        }

        function stripeHandleCardAction(transaction) {
          const stripe = Stripe(STRIPE_PUBLISHABLE_KEY);
          stripe.handleCardAction(transaction.ccPaymentIntentClientSecret)
            .then(function (response) {
              if (response.paymentIntent) {
                scope.printixCardActionHandled(transaction);
              }
              if (response.error) {
                transaction.working = false;
              }
            })
            .catch(function () {
            });
        }

        scope.printixCardActionHandled = function (transaction) {
          transaction.working = true;
          scope.cardActionHandled(transaction)
            .then(function (response) {
              transaction.working = false;
            })
            .catch(function () {
              transaction.working = false;
            });
        };

        function retryPayment(transaction) {
          transaction.working = true;
          scope.tenant.retryPayment(transaction)
            .then(function (response) {
              transaction.working = false;
            })
            .catch(function () {
              transaction.working = false;
            });
        };

        scope.cancelTransaction = function (transaction) {
          transaction.working = true;
          scope.tenant.cancelTransaction(transaction)
            .then(function (response) {
              getTransactionsListPaged();
              transaction.working = false;
            })
            .catch(function () {
              transaction.working = false;
            });
        };

        scope.getInvoice = function (transaction) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          $http.get(transaction._links['px:invoicePdf'].href, { responseType: 'arraybuffer' })
            .then(function (response) {
              const filename = filenameRegex.exec(response.headers('Content-Disposition'))[1];
              saveAs(new Blob([response.data], { type: 'application/pdf' }), filename);
            })
            .catch(function (response) {
            });
        };

        scope.showEnterInvoiceInput = function (transaction) {
          const enterInvoiceInputOptions = {
            scope,
            templateUrl: TEMPLATE_PATHS.ENTER_INVOICE_NUMBER_TEMPLATE_PATH,
            title: $filter('translate')('EnterNumber'),
            buttons: {
              warning: {
                className: 'btn-default',
                label: $filter('translate')('Cancel')
              },
              success: {
                className: 'btn-primary',
                label: $filter('translate')('Send'),
                callback: function () {
                  if (scope.invoiceNumber) {
                    // This function has not been implemented.
                    // scope.sendInvoiceNumber(transaction._links['px:registerInvoiceBooked'], scope.invoiceNumber);
                  }
                }
              }
            }
          };
          $ngBootbox.customDialog(enterInvoiceInputOptions);
        };

        scope.getCardExpiryData = function (transaction) {
          const cardExpiryDataMonth = transaction.ccExpiry.toString().slice(4, 6);
          const cardExpiryDataYear = transaction.ccExpiry.toString().slice(0, 4);
          return cardExpiryDataMonth + ' / ' + cardExpiryDataYear;
        };

        const deregisterCreditCardChargeCreatedListener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.CREDIT_CARD_CHARGE_CREATED, function (event, data) {
          getTransactionsListPaged();
        });

        const deregisterCreditCardChargeUpdatedListener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.CREDIT_CARD_CHARGE_UPDATED, function (event, data) {
          getTransactionsListPaged();
        });

        const deregisterCreditCardChargeDeletedListener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.CREDIT_CARD_CHARGE_DELETED, function (event, data) {
          getTransactionsListPaged();
        });

        scope.$on('$destroy', function () {
          deregisterCreditCardChargeCreatedListener();
          deregisterCreditCardChargeUpdatedListener();
          deregisterCreditCardChargeDeletedListener();
        });

      }
    };
  }

  pxTransactions.$inject = [
    '$filter', '$http', 'TransactionsListPaging', 'STRIPE_PUBLISHABLE_KEY', '$rootScope',
    'EventServiceEvents', 'TEMPLATE_PATHS', '$ngBootbox', '$translate'
  ];

  angular
    .module('printix-admin')
    .directive('pxTransactions', pxTransactions);

})();
